import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import tools from '../../utils/tools';
import styles from './pay.module.less';
import { getQRCodeSetting } from '../../service/chat-service';

// 图片资源
import bg from '../../public/images/rwx_buy_img-payback.png';
import success from '../../public/images/rwx_buy_icon_pay_success.png';

// import fail from '../../public/images/rwx_buy_icon_pay_fail.png';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

class PayResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // type: tools.getQueryString('type'),
      showQRCode: false,
      QRCodeImageUrl: null,
      guideType: null,
    };
  }

  componentDidMount() {
    document.title = '支付结果';
    this.checkShowQRCode();
  }

  // 返回产品页
  returnProduct = () => {
    const { history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const productId = tools.getQueryString('productId');
    history.push(`/productDetail?shareUserId=${shareUserId}&productId=${productId}`);
  };

  // 跳转订单详情
  jumpOrderDetail = () => {
    const { history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const productId = tools.getQueryString('productId');
    const orderId = tools.getQueryString('orderId');
    history.push(`/orderDetail?shareUserId=${shareUserId}&productId=${productId}&orderId=${orderId}`);
  };

  /**
   * 获取是否要展示二维码
   */
  checkShowQRCode = () => {
    const productId = tools.getQueryString('productId');
    getQRCodeSetting(productId).then((res) => {
      const { code, data, message } = res;

      if (code !== 10000) return Toast.show(message);

      const showQRCode = data.isEnableQrcode === 0;
      const { guideType } = data;
      const QRCodeImageUrl = data.qrcodeUrl;
      const { qrcodeTitle } = data;

      this.setState({
        showQRCode, QRCodeImageUrl, qrcodeTitle, guideType,
      });
      return true;
    }).catch((error) => {
      Toast.show(error);
    });
  };

  handleJumpLink = () => {
    const { QRCodeImageUrl } = this.state;
    let url = QRCodeImageUrl;

    if (!QRCodeImageUrl.startsWith('http')) {
      url = `http://${url}`;
    }
    window.open(url, '_blank');
  };

  render() {
    const {
      showQRCode, QRCodeImageUrl, qrcodeTitle, guideType,
    } = this.state;
    const html = (
      <div className={styles.position}>
        <img src={success} alt="" />
        <span>支付完成</span>
      </div>
    );
    const btnHtml = (
      <div className={styles.btns_box}>
        <Button
          onClick={this.returnProduct.bind(this)}
          className={styles.return_product}
        >
          返回产品页
        </Button>
        <Button
          onClick={this.jumpOrderDetail.bind(this)}
          className={styles.againPay}
        >
          订单详情
        </Button>
      </div>
    );

    return (
      <div className={styles.pay_result}>
        <img src={bg} alt="" />
        {html}
        {btnHtml}
        {showQRCode && guideType === 1 && (
          <div className={styles.QRCodeBox}>
            <img src={QRCodeImageUrl} alt="QRCodeImageUrl" />
            <p className={styles.weightFont}>{qrcodeTitle}</p>
          </div>
        )}

        {
          showQRCode && guideType === 2
          && (
          <div className={styles.linkButton} onClick={this.handleJumpLink} role="button" tabIndex={0}>
            {qrcodeTitle}
          </div>
          )
        }
      </div>
    );
  }
}

PayResult.propTypes = propTypes;
PayResult.defaultProps = defaultProps;

export default withRouter(PayResult);
